export const zIndexs = {
  appBar: 800,
  /** @description keep it under 1000 to have google searchbar functioning */
  takeOver: 900,
}
